import { Checkbox, InputAdornment, TextField } from "@mui/material";

interface TextFieldWithCheckboxProps {
	checkboxValue: boolean;
	label?: string;
	disabled?: boolean;
	onCheckboxChange: (checked: boolean) => void;
	onFocus?: () => void;
	onBlur?: () => void;
}

export const TextFieldWithCheckbox = ({
	checkboxValue,
	label,
	disabled = false,
	onCheckboxChange,
	onFocus,
	onBlur,
}: TextFieldWithCheckboxProps) => {
	return (
		<TextField
			fullWidth
			size="small"
			variant="outlined"
			label={label}
			value=""
			disabled
			onFocus={onFocus}
			onBlur={onBlur}
			InputLabelProps={{
				style: {
					color: "black",
				},
			}}
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<Checkbox
							checked={checkboxValue}
							onChange={(e) => onCheckboxChange(e.target.checked)}
							color="primary"
							disabled={disabled}
							size="small"
						/>
					</InputAdornment>
				),
			}}
		/>
	);
};
